export enum UserRoles {
  SystemAdmin = "System Admin",
  AppAdmin = "App Admin",
  AppUser = "App User",
  SimpleUser = "Simple User",
}

export interface User {
  id?: number;
  first_name: string;
  last_name: string;
  email: string;
  password: string;
  phone: number;
  verification_url?: string;
  is_verified?: boolean;
  created_at?: Date;
  updated_at?: Date;
  role: UserRoles;
  token: string;
  deleted_at: Date;
  username: string;
  max_bookings: number;
}


export interface Client {
  id?: number;
  first_name: string;
  last_name: string;
  email: string;
  password: string;
  guid:string;
  verified:string;
  phone: number;
  verification_code?: string;
  fcm_token:string;
  created_at?: Date;
  updated_at?: Date;
  deleted_at: Date;
}
